import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-downtime-warning',
  templateUrl: './downtime-warning.component.html',
  styleUrls: ['./downtime-warning.component.css']
})
export class DowntimeWarningComponent {
  images = {
    CROSS: CROSS,
  };

  constructor(private dialogRef: MatDialogRef<DowntimeWarningComponent>) {}

  close() {
    this.dialogRef.close();
  }
}